<template>
  <ul class="top">
    <li class="top__title">
      <!-- title -->
      <h1
        v-if="title"
        v-html="title"
      />
      <span v-if="copy">{{ copy }}</span>
    </li>
  </ul>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    copy: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>

.top {
  display: flex;
  flex: 1;
  justify-content: space-between;

  h1 {
    font-family: $f-graphie-bold;
    font-size: 40px;
    text-transform: lowercase;
  }

  &__title {
    color: $c-tundora;
    display: flex;
    flex-direction: column;

    h3 {
      font-family: $f-graphie-bold;
      text-transform: uppercase;
    }

    span {
      @include font-size(11px);
    }
  }

  &__social-media {
    ul {
      display: flex;
      flex-direction: row;

      li {
        margin-left: 20px;
      }
    }
  }
}
</style>
